import React, { useState } from "react";
import CustomInput from "../../shared/CustomInput/CustomInput";
import CustomDropdown from "../../shared/CustomDropDown/CustomDropdown";
import { Box, Button } from "@mui/material";
import "./MarketingForm.scss";
import UnifiedButton from "../../shared/Button";

function MarketingForm() {
    const [helpIn, setHelpIn] = useState("");
    const [audioFile, setAudioFile] = useState(null);

    const helpOptions = [
        { label: "Music Video Production", value: "music_video_production" },
        { label: "Creative Development", value: "creative_development" },
        { label: "Technical Production", value: "technical_production" },
        { label: "Project Management", value: "project_management" },
    ];

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.size <= 100 * 1024 * 1024) {
            setAudioFile(file);
        } else {
            alert("File size exceeds 100MB.");
        }
    };

    return (
        <Box className="marketing-form-section">
            <div className="form-row">
                <CustomInput
                    label="First Name"
                    placeholder="Enter your first name"
                    fullWidth
                />
                <CustomInput
                    label="Last Name"
                    placeholder="Enter your last name"
                    fullWidth
                />
            </div>

            <div className="form-row">
                <CustomInput label="Email" placeholder="Enter your email" fullWidth />
                <CustomInput
                    label="Mobile no."
                    placeholder="Enter your mobile number"
                    fullWidth
                />
            </div>

            <div className="form-row">
                <CustomDropdown
                    label="Help in"
                    value={helpIn}
                    onChange={(e) => setHelpIn(e.target.value)}
                    options={helpOptions}
                    placeholder="Select one"
                />
            </div>

            <div className="form-row">
                <CustomInput
                    label="Budget you are spending on video"
                    placeholder="Enter your budget"
                    fullWidth
                />
                <CustomInput
                    label="Sponsored brand"
                    placeholder="Enter sponsored brand"
                    fullWidth
                />
            </div>

            <div className="form-row">
                <CustomInput
                    label="Audio Attachment (less than 100MB)"
                    type="file"
                    onChange={handleFileChange}
                    fullWidth
                />
            </div>

            <Box
                sx={{ display: "flex", justifyContent: "center", marginTop: "20px" }}
            >
                <UnifiedButton
                    className={"marketing-form-button"}
                    variant="contained"
                    textContent={"Submit"}
                    fullWidth
                    sx={{ mt: 2, color: "white" }}
                />
            </Box>
        </Box>
    );
}

export default MarketingForm;
